import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as MedReviewActions from '../actions/med-review.actions';
import { MedReviewService } from '../services/med-review.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class MedReviewEffects {
  loadMedReviews$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MedReviewActions.loadMedReviews),
      concatMap((payload) =>
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        this.medReviewService.loadMedReviewData(payload.page, payload?.patientId).pipe(
          map((data) => {
            this.medReviewService
              .getMedScore(data.data.map((d) => d.patient_id))
              .subscribe((res) => {
                const hash = [];
                res.forEach((r) => {
                  hash[r.knostos_id] = r.mrs;
                });
                let x = data.data.map((d) => {
                  // d =
                  // d.mrs = hash[d.patient_id] || Math.floor(Math.random() * 50)
                  return d;
                });
                x = x.map((d) => {
                  d = { ...d };
                  d.mrs = hash[d.patient_id] || 0;
                  return d;
                });
                this.store.dispatch(MedReviewActions.loadMedReviewsSuccess({ ...data, data: x }));
              });
            return MedReviewActions.loadMedReviewsSuccess(data);
          }),

          catchError((error) => of(MedReviewActions.loadMedReviewsFailure({ error }))),
        ),
      ),
    );
  });

  loadBamboohealthCheck$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MedReviewActions.loadBamboohealthCheck),
      concatMap((payload) =>
        this.medReviewService
          .loadMedreviewBmabooHealthData(payload.triggerType, payload.medReviewId)
          .pipe(
            map((data) => {
              // Return the success action with the data
              return MedReviewActions.loadBamboohealthCheckSuccess({ data });
            }),
            catchError((error) => {
              // Return the failure action with the error
              this.snackBar.open( error.message, 'Close', {
                duration: 5000,
              });
              return of(MedReviewActions.loadBamboohealthCheckFailure({ error }));
            }),
          ),
      ),
    );
  });
  constructor(
    private actions$: Actions,
    private medReviewService: MedReviewService,
    private store: Store<AppState>,
    private snackBar: MatSnackBar
) {}
}
